/* The exercise library page — KANON `Cwiczenia` 17.09.2026, variant e.
 *
 * The SHELL is `shared/ui/canonScreen`: `.page` and `.measure` are not here, because v2's rule —
 * content holds a measure of about 1600px and centres in it rather than filling a 32" monitor by
 * force — is one screen's rule as much as any other's.
 *
 * What is here is the two panes and the card the table sits in. */

/* The two panes under the header, with the canon's own 16px between them. Both are bounded and each
 * scrolls inside itself, which is what keeps the toolbar, the scope switch and the panel's identity
 * row on screen at row four hundred.
 *
 * `min-height: 0` is what makes that real: a flex item's default `min-height: auto` refuses to
 * shrink below its content, so without it the pane grows to the height of the whole catalogue and
 * the page scrolls instead of the table. */
.pane {
  display: flex;
  flex: 1;
  gap: var(--space-4);
  min-height: 0;
  overflow: hidden;
}

/* The table's card. It holds the toolbar, the scope switch, the column band and the rows, and it is
 * the pane that GROWS: `flex: 1` with a floor, so the panel beside it keeps its fixed width and the
 * surplus on a wide monitor goes to the flexible ĆWICZENIE and PARTIE columns.
 *
 * The floor is the specimen's own `min-width: 700px`. Below it the table's own scroller takes over
 * sideways rather than the columns collapsing — a clip with no scroll path is the one outcome
 * `CLAUDE.md` names as worse than either.
 *
 * All five absences sit in this same box, for the reason the canon gives the table one: "nie udało
 * się wczytać" belongs on the surface the rows would have been on, not on the canvas. */
.card {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 700px;
  min-height: 0;
  overflow: hidden;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-11px);
  box-shadow: var(--shadow-card);
}

/* The preview column's own slot. `flex: none` and no width of its own — the panel inside it states
 * its 396, because that is the measure its cards' type is calibrated on. `min-height: 0` again, so
 * the column scrolls inside itself rather than growing the pane. */
.side {
  display: flex;
  flex: none;
  flex-direction: column;
  min-height: 0;
}

/* ── Where the breakpoint went ───────────────────────────────────────────────────────────────
 *
 * There used to be a `@media (width < 1424px) { .side { display: none } }` here, and it was the
 * screen's SECOND opinion on whether the panel is drawn. The toolbar's `aria-pressed`, the
 * toolbar's title and the muscle cap the table draws all read the stored preference instead, so at
 * 1300px the table drew the narrow cut with no panel beside it and the toggle reported a state
 * about a column nobody could see.
 *
 * `model/panelPreference`'s `PANEL_FITS_QUERY` is the one place that number lives now, and
 * `usePanelPreference` subscribes to it: the column is not rendered below the breakpoint rather
 * than rendered and hidden. Nothing in this stylesheet may name a width again without putting the
 * same disagreement back. */
